import { WaterfallTierTypeEnum } from "gen/model/waterfallTierTypeEnum";
import { TFunction } from "i18next";

export const localizeTierType = (
  t: TFunction<["enums"]>,
  type: WaterfallTierTypeEnum,
) => t(`enums:WaterfallTierTypeEnum.${type}`);
